import { useSnackbar } from "notistack";
import React, { useContext } from "react";
import "react-perfect-scrollbar/dist/css/styles.css";
import { Alert, Snackbar } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { ThemeProvider } from "styled-components/macro";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { HelmetProvider, Helmet } from "react-helmet-async";
import {
  ThemeProvider as MuiThemeProvider,
  StyledEngineProvider,
} from "@mui/material/styles";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

import "react-perfect-scrollbar/dist/css/styles.css";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "./pages/welcome page components/style.css";
import "./pages/css components/style.css";

import createTheme from "./theme";
import Router from "./router/Router";
import { closeAlert } from "./redux/slices/alertSlice";
import { ThemeContext } from "./components/ThemeProvider";
import AuthVerification from "./components/AuthVerification";

// const history = createBrowserHistory({ basename: "/v1" });
export var siteColors = JSON.parse(sessionStorage.getItem("siteColors"));

function App() {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { theme } = useContext(ThemeContext);
  const alert = useSelector((state) => state.alertDetails);

  function handleAlertClose(_, reason) {
    if (reason === "clickaway") return;
    dispatch(closeAlert());
  }

  return (
    <HelmetProvider>
      <Helmet
        titleTemplate="%s | Smart Digital Advertising"
        defaultTitle="Smart Digital Advertising"
      />
      <StyledEngineProvider injectFirst>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <StyledEngineProvider injectFirst>
            <MuiThemeProvider theme={createTheme(theme)}>
              <ThemeProvider theme={createTheme(theme)}>
                {alert.multiple ? (
                  alert.multiple.map((msg) => (
                    <div style={{ display: "none" }}>
                      {enqueueSnackbar(msg, {
                        variant: alert.type,
                        autoHideDuration: 4000,
                        anchorOrigin: { vertical: "top", horizontal: "right" },
                      })}
                    </div>
                  ))
                ) : (
                  <Snackbar
                    open={alert.state}
                    autoHideDuration={4000}
                    onClose={handleAlertClose}
                    style={{ minWidth: "350px" }}
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                  >
                    <Alert
                      variant="filled"
                      severity={alert.type}
                      onClose={handleAlertClose}
                      style={{ minWidth: "350px" }}
                    >
                      {alert.message}
                    </Alert>
                  </Snackbar>
                )}

                <Router />
                <AuthVerification />
              </ThemeProvider>
            </MuiThemeProvider>
          </StyledEngineProvider>
        </LocalizationProvider>
      </StyledEngineProvider>
    </HelmetProvider>
  );
}

export default App;
